import { NavigationBottom } from './NavigationBottom';
export default NavigationBottom;
